module.exports = __webpack_public_path__ + "static/track-c3b36e77b17f0389b31e42213f1a588d.jpg";